import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { LOYALTY_USER_TERMS_AND_CONDITIONS_PAGE_PATH } from "utils/constants/paths";

const LoyaltyUserTermsAndConditionsPage = Loadable(React.lazy(() => import("./View")));

export const LoyaltyUserTermsAndConditionsPageRoute: IRouteItem = {
  path: LOYALTY_USER_TERMS_AND_CONDITIONS_PAGE_PATH,
  element: React.createElement(LoyaltyUserTermsAndConditionsPage),
  name: "Loyalty User Terms And Conditions",
};
